import { isStoreBuild } from './platform';

/**
 * Начатый, но не проверенный ответ в уроке (24.09.2026, сборка 61).
 *
 * ЗАЧЕМ. В приложении появился свайп назад от края — уйти из урока стало легко случайно. Ответ задания живёт на
 * экране, пока ученик не нажал «Проверить»: выбранный вариант, заполненные пропуски, собранное слово пропадают
 * при уходе. Решение владельца 24.09: при уходе с таким ответом — окно «Выйти из урока? Ответ не сохранён» /
 * «Остаться» / «Выйти». Нет ответа или он уже проверен — уходим без окна.
 *
 * КАК. Задание, в котором ученик что-то ввёл, выбрал или нажал, — «тронуто» (`touch`). Ответ ушёл через
 * `onAnswer` — «успокоено» (`settle`). Задание ушло с экрана (раздел сменился) — тоже `settle`: вопрос задаётся
 * про тот экран, с которого уходят. Считает `components/lesson/BlockView.tsx`, спрашивает
 * `hooks/useLeaveWhileRecording.ts` (он же держит единственный `useBlocker` страницы).
 *
 * ⚠️ ТОЛЬКО В ПРИЛОЖЕНИИ. На сайте уход из урока ведёт себя как раньше — `touch` там ничего не отмечает.
 * ⚠️ ЧЕРНОВИКА ЗДЕСЬ НЕТ. Ответ не сохраняется, окно лишь предупреждает. Черновики всех типов — отдельный заход
 * после 61 (техдолг). Сочинение и запись голоса сюда не попадают: у сочинения свой черновик, у записи — свой
 * сторож и черновик в IndexedDB.
 */

const touched = new Set<string>();
const listeners = new Set<() => void>();

function emit(): void {
  for (const fn of listeners) fn();
}

export function touchAnswer(blockId: string): void {
  if (!isStoreBuild() || touched.has(blockId)) return;
  touched.add(blockId);
  emit();
}

export function settleAnswer(blockId: string): void {
  if (!touched.delete(blockId)) return;
  emit();
}

export function unsavedAnswers(): number {
  return touched.size;
}

export function subscribeAnswers(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/**
 * Считается ли нажатие началом ответа. Не считаются: плееры (кнопка «играть» — не ответ; отмечены
 * `data-no-dirty`) и нажатия мимо органов управления (по тексту задания, по картинке).
 * `[data-answer]` — то, что отвечает, не будучи кнопкой: слово в «выделите слова».
 */
export function isAnswerGesture(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  if (target.closest('[data-no-dirty]')) return false;
  return !!target.closest(
    'button, [role="button"], [role="radio"], [role="checkbox"], label, input, select, textarea, [draggable="true"], [data-answer]',
  );
}

/** Только для проверок. */
export function __resetAnswersForTests(): void {
  touched.clear();
  listeners.clear();
}
